export default "__VITE_ASSET__O$k6PdSy__"